import { useState, useCallback } from "react";
import { apiGet, apiPost, endpoints } from "../api/client";
import type { IntegrityCheckResponse } from "../api/types";

export function useIntegrity() {
  const [latest, setLatest] = useState<IntegrityCheckResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchLatest = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiGet<IntegrityCheckResponse>(endpoints.integrityLatest);
      setLatest(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load integrity check");
    } finally {
      setLoading(false);
    }
  }, []);

  const triggerCheck = useCallback(async () => {
    setChecking(true);
    setError(null);
    try {
      await apiPost(endpoints.integrityCheck);
      await new Promise((r) => setTimeout(r, 2000));
      await fetchLatest();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to trigger check");
    } finally {
      setChecking(false);
    }
  }, [fetchLatest]);

  return { latest, loading, checking, error, fetchLatest, triggerCheck };
}
